import { useContext, useEffect, useMemo } from "react";
import UserContext from "../context";
import { useNavigate } from "react-router-dom";
import { HomeService } from "../services/home";

const RouterProtect: React.FC<{ children: any }> = ({ children }) => {
  const ctx = useContext(UserContext);
  
  const instance = useMemo(() => new HomeService(), []); // Instância criada fora do useEffect

  const navigate = useNavigate();

  useEffect(() => {
    const checkApiAndNavigate = async () => {
      if (!ctx?.user) {
        const apiIsOnline = await instance.test();
        console.log('apiIsOnline', apiIsOnline);
        if (apiIsOnline) {
          navigate("/minha-innova");
        } else {
          navigate("/error-servidor");
        }
      }
    };

    checkApiAndNavigate(); // Chama a função criada
  }, [ctx?.user, navigate, instance]); // Adiciona `instance` ao array de dependências

  return children;
};

export default RouterProtect;